export default '<svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg" transform="rotate(-90)">\
  <path d="M1.29996 10.355L9.96997 1.68402L18.641 10.355" stroke="var(--color)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\
</svg>'
